import React from 'react';
import { useDataTableContext } from '../../../utils/DataTableContext';
import { ChipSelect } from '../../../../ChipsSelect/ChipSelect';
import { SystemIconButton } from '../../../../Icon';

interface PermanentFilterButtonProps {
  label: string;
  valueLabel?: string | undefined;
  active?: boolean;
  dataTest?: string;
  onClick?: () => void;
  onDelete?: () => void;
}

export const PermanentFilterButton = ({
  dataTest,
  label,
  valueLabel,
  onClick,
  onDelete,
  active
}: PermanentFilterButtonProps) => {
  const { selectedRows } = useDataTableContext();
  const defaultClickHandler = (event: React.MouseEvent) => event.preventDefault();
  const selected = active || !!valueLabel;
  return (
    <ChipSelect
      label={
        <>
          {valueLabel || label}
          {selected && !!onDelete && (
            <SystemIconButton
              iconName="clear"
              size="x-small"
              style={{ marginTop: -1 }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onDelete?.();
              }}
            />
          )}
        </>
      }
      variant="outlined"
      dataTest={dataTest}
      onClick={onClick ?? defaultClickHandler}
      disabled={(selectedRows?.length ?? 0) > 0}
      selected={selected}
    />
  );
};
